import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const  dateTimeFormats = {
  'en': {
    short: {
      month: 'numeric', day: 'numeric', year: 'numeric'
    },
    long: {
      month: 'numeric', day: 'numeric', year: 'numeric',
      hour: 'numeric', minute: 'numeric', hour12: true
    }
  },
  'de': {
    short: {
      day: 'numeric', month: 'numeric',  year: 'numeric'
    },
    long: {
      day: 'numeric', month: 'numeric', year: 'numeric',
      hour: 'numeric', minute: 'numeric', hour12: false
    }
  }
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'de',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'de',
  silentFallbackWarn: true,
  dateTimeFormats
})

